import { render, staticRenderFns } from "./SidBarPendentes.vue?vue&type=template&id=094e61f0&scoped=true&"
import script from "./SidBarPendentes.vue?vue&type=script&lang=js&"
export * from "./SidBarPendentes.vue?vue&type=script&lang=js&"
import style0 from "./SidBarPendentes.vue?vue&type=style&index=0&id=094e61f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e61f0",
  null
  
)

export default component.exports